import { Skeleton } from "antd"
import React, { Suspense, lazy } from "react"
import { Outlet, type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import { COUNTERSIGN_PERMISSION } from "../../../Esign/hooks/use-countersign.ts"
import { SEND_FOR_SIGNATURE_PERMISSION } from "../../../Esign/hooks/use-send-for-signature.ts"

import { lazyPage } from "../lazyPage.tsx"

const SignatureRequestsGate = lazyPage(() =>
  import("../../../Esign/TrackingPage/SignatureRequestsGate.tsx").then((m) => ({
    default: m.SignatureRequestsGate
  }))
)
const SignatureRequestsPage = lazyPage(
  () => import("../../../Esign/TrackingPage/SignatureRequestsPage.tsx")
)
const EsignComposePage = lazy(
  () => import("../../../Esign/EsignComposePage.tsx")
)

const CountersignPage = lazy(() => import("../../../Esign/CountersignPage.tsx"))

const RequestDetailPage = lazy(
  () => import("../../../Esign/RequestDetailPage.tsx")
)

const gated = (
  <PermissionGate paths={[SEND_FOR_SIGNATURE_PERMISSION]}>
    <Suspense fallback={null}>
      <EsignComposePage />
    </Suspense>
  </PermissionGate>
)

// The wizard is a modal over EZ-Sign, as New Lead is over the leads list: one
// layout keeps the manager mounted while the wizard opens and closes over it.
const managerWithWizard = (
  <>
    <SignatureRequestsGate>
      <SignatureRequestsPage />
    </SignatureRequestsGate>
    <Outlet />
  </>
)

const countersignGated = (
  <PermissionGate paths={[COUNTERSIGN_PERMISSION]}>
    <Suspense fallback={<Skeleton active paragraph={{ rows: 6 }} />}>
      <CountersignPage />
    </Suspense>
  </PermissionGate>
)

// Reading a sent request follows the record, like the manager list: no right of its own.
const requestDetail = (
  <SignatureRequestsGate>
    <Suspense fallback={<Skeleton active paragraph={{ rows: 6 }} />}>
      <RequestDetailPage />
    </Suspense>
  </SignatureRequestsGate>
)

// Ahead of envelopePath, or "/sign" would be read as an envelope id.
export const esignRoutes: RouteObject[] = [
  {
    element: managerWithWizard,
    children: [
      { path: RoutesPaths.signatureRequests, element: null },
      { path: RoutesPaths.esign.newEnvelopePath, element: gated },
      { path: RoutesPaths.esign.envelopePath, element: gated }
    ]
  },
  { path: RoutesPaths.esign.signPath, element: countersignGated },
  { path: RoutesPaths.esign.requestPath, element: requestDetail }
]
